// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shadow-none[data-v-1c15957e]{box-shadow:none!important}.delivery-address-wrapper .card[data-v-1c15957e]{transition:background-color .15s ease-in-out}.delivery-address-wrapper .card[data-v-1c15957e]:hover{background-color:#f1f1f1}", ""]);
// Exports
module.exports = exports;
